import React from 'react';

const Header = () => {
    return (
        <header className={"pl-4 font-bold bg-orange-600 text-white text-2xl w-full h-20 flex justify-start items-center"}>
            <h1>SPOTTR.</h1>
        </header>
    );
};

export default Header;